import { useState, useMemo } from "react";
import { Container, Row, Col, Card, Button, Form, Tab, InputGroup } from "react-bootstrap";
import { t } from "i18next";
import Functions from "../../../General/Functions";

const SecurityTabContent = ({ setShowResetModal, setNewPassword,setShowConfirmReset }) => {

    return (
        <Tab.Pane eventKey="security">
            <Card className="shadow-sm">
                <Card.Body>
                    <div className="mb-4">
                        <h5 className="mb-1 d-flex align-items-center">
                            <i className="bi bi-shield-lock me-2 text-primary" />
                            {t("security_settings")}
                        </h5>
                        <small className="text-muted">
                            {t("security_description")}
                        </small>
                    </div>
                    {/* Password Management */}
                    <Card className="border-warning mb-3">
                        <Card.Body>
                            <h6 className="mb-2 d-flex align-items-center">
                                <i className="bi bi-key me-2 text-warning" />
                                {t("password_management")}
                            </h6>

                            <p className="text-muted mb-3">
                                {t("password_management_info")}
                            </p>

                            <Button
                                variant="outline-warning"
                                onClick={() => {
                                    /*const pwd = Functions.generatePassword();
                                    setNewPassword(pwd);
                                    setShowResetModal(true)*/setShowConfirmReset(true)
                                }}
                            >
                                {t("reset_password")}
                            </Button>
                        </Card.Body>
                    </Card>
                    {/* Security info */}
                    <div className="text-muted small">
                        <i className="bi bi-info-circle me-1" />
                        {t("password_reset_audit_notice")}
                    </div>
                </Card.Body>
            </Card>
        </Tab.Pane>
    );
};

export default SecurityTabContent;
